import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {FileManager} from "../../../../shared/interface/file-manager";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {srcFileManager} from "../../../../../environments/environment";
import {MatDialog} from "@angular/material/dialog";
import {FileManagerService} from "../../../../shared/services/file-manager.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {FilterService} from "../../../../shared/services/filter.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {SharedFile} from "../../../../shared/interface/shared-file";
import {SharedFileService} from "../../../../shared/services/shared-file.service";
import {AddFileDialogComponent} from "../../add-file-dialog/add-file-dialog.component";
import {SharedFileAddComponent} from "../shared-file-add/shared-file-add.component";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {Profile} from "../../../../shared/interface/profile";

@Component({
  selector: 'app-all-shared-file-list',
  templateUrl: './all-shared-file-list.component.html',
  styleUrls: ['./all-shared-file-list.component.scss']
})
export class AllSharedFileListComponent implements OnInit, OnDestroy, AfterViewInit  {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  totalData = 0;
  displayedColumns: string[] = ['fileName', 'cratedAt', 'removeAt', 'pasword', 'user',  'download'];
  sharedFile: SharedFile[] = [];
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  initialFilters: any;
  readonly  srcFileManager = srcFileManager;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private sharedFileService: SharedFileService,
    private auth: AuthService,
    private store: Store<StoreRootState>,
    private filterService: FilterService,
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.sharedFileService.getSharedFileListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<SharedFile>) => {
          this.sharedFile = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  ngOnInit(): void {
    this.activatedRoute.params

      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        if (params.id) {
          this.filter();

        }
      });
    this.parseFilters();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.resetFilters();
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.loadListData();
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.loadListData();
    });
  }

  loadListData(): void {
    this.sharedFileService.loadList(this.buildFilters(),
      this.paginator?.pageIndex, this.paginator?.pageSize
    );

  }

  filter(): void {
    this.loadListData();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({}, filters);
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.loadListData();
  }

  add(): void {
    const dialogRef = this.dialog.open(SharedFileAddComponent, {
      width: '50vw',
      maxHeight: '90vh',
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  getLink(sharedFile: SharedFile): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.srcFileManager.sharedFileLink + sharedFile.uuid;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka link' , '', {duration: 2000});
  }

  deleteSharedFile(uuid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć plik ?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sharedFileService.deleteSharedFile(uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto plik', '', {duration: 2000});
              this.loadListData();
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 5000});
            }
          });
      }
    });
  }
  isExpired(dateString: string | Date): boolean {
    if (!dateString) return false;
    const expirationDate = new Date(dateString);
    const today = new Date();
    return expirationDate < today;
  }

}
